import { useMemo } from 'react';
import initializeClient from '#providers/apollo/initializeClient';
import createDevClient from '#providers/apollo/createDevClient';
import { NormalizedCacheObject } from '@apollo/client';

type props = {
  initialState?: NormalizedCacheObject;
  context?: {
    resolvedUrl?: string;
    locale?: string;
  };
  enableDevClient?: boolean;
};

export function useApollo({
  initialState,
  context = null,
  enableDevClient = false,
}: props = {}) {
  return useMemo(() => {
    if (enableDevClient) {
      return createDevClient();
    }

    return initializeClient({ initialState, context });
  }, [initialState, enableDevClient]);
}
